import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import { supabase } from "utils/supabase";
import { Link, useHistory } from "react-router-dom";
import enarmApexLogo from "assets/img/enarm-apex-logo.png";

export default function PagoRealizado() {
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState("");
    const [isChecking, setIsChecking] = useState(true);
    const [paymentNotReceived, setPaymentNotReceived] = useState(false);

    useEffect(() => {
        const waitForSubscription = async () => {
            setErrorMessage("");
            setIsChecking(true);
            setPaymentNotReceived(false);
            let failedByError = false;

            for (let i = 0; i < 10; i++) {
                const { data, error } = await supabase.rpc("get_billing_status");

                if (error) {
                    setErrorMessage("No pudimos verificar tu suscripcion. Intenta de nuevo.");
                    failedByError = true;
                    break;
                }

                if (!error && data?.has_pro_access) {
                    history.replace("/admin/dashboard");
                    return;
                }

                await new Promise((resolve) => setTimeout(resolve, 1500));
            }

            if (!failedByError) {
                setPaymentNotReceived(true);
            }
            setIsChecking(false);
        };

        waitForSubscription();
    }, [history]);

    return (
        <>
            <div className="container mx-auto px-4 h-full">
                <div className="flex content-start items-start justify-center h-full">
                    <div className="w-full lg:w-5/12 px-4 -mt-20">
                        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
                            <div className="rounded-t mb-0 px-6 py-6">
                                <div className="text-center mb-3">
                                    <img
                                        src={enarmApexLogo}
                                        alt="ENARM Apex Logo"
                                        className="w-32 mx-auto"
                                        style={{ width: "20rem" }}
                                    />
                                    <br />
                                    <h6 className="text-blueGray-500 text-lg font-bold">
                                        Verificando suscripcion
                                    </h6>
                                    <p className="text-sm text-blueGray-500 mt-2">
                                        Espera un momento mientras confirmamos tu pago.
                                    </p>
                                </div>
                            </div>

                            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                                {errorMessage && (
                                    <Alert severity="error" className="mb-4">
                                        {errorMessage}
                                    </Alert>
                                )}

                                <div className="flex flex-col items-center justify-center py-6">
                                    {isChecking && (
                                        <>
                                            <div className="h-12 w-12 rounded-full border-4 border-blueGray-300 border-t-lightBlue-500 animate-spin mb-4"></div>
                                            <p className="text-sm text-blueGray-600 font-semibold">
                                                Validando acceso PRO...
                                            </p>
                                        </>
                                    )}

                                    {!isChecking && paymentNotReceived && (
                                        <>
                                            <p className="text-sm text-blueGray-600 font-semibold mb-4 text-center">
                                                Pago no recibido. Si ya realizaste el pago, intenta iniciar sesion de nuevo en unos minutos.
                                            </p>
                                            <button
                                                type="button"
                                                onClick={() => history.push("/auth/login")}
                                                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none w-full ease-linear transition-all duration-150"
                                            >
                                                Ir a login
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="text-center mt-2">
                            <Link to="/auth/login" className="text-blueGray-200">
                                <small>Volver a iniciar sesion</small>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
